import React from 'react';
import styled from 'styled-components';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';

const Dashboard = ({ profileData, bgImage, onBarClick }) => {
  const getBarColor = (name) => {
    switch (name) {
      case 'CIS Bohol':
        return '#46be78'; // Green
      case 'CIS Siquijor':
        return '#FFB300'; // Yellow
      case 'CIS Noso':
        return '#A6D84D'; 
      default:
        return '#42A5F5'; // Default Blue
    }
  };

  return (
    <DashboardBox>
      <DashboardHeader>
        <DashboardTitle>Dashboard</DashboardTitle>
      </DashboardHeader>

      <DashboardPreview bgImage={bgImage} />

      <ProfileHeader>
        <ProfilingTitle>Profiling Summary</ProfilingTitle>
      </ProfileHeader>

      <ChartWrapper>
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={profileData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" interval={0} angle={-9} textAnchor="end" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" radius={[10, 10, 0, 0]}>
               {profileData.map((entry, index) => (
           <Cell
            key={`cell-${index}`}
      fill={getBarColor(entry.name)}
      onClick={() => onBarClick(entry)} // <<<< HERE
    />
  ))}
</Bar>

          </BarChart>
        </ResponsiveContainer>
      </ChartWrapper>
    </DashboardBox>
  );
};

export default Dashboard;


const DashboardBox = styled.div`
  max-width: 1300px;
  flex-grow: 2;
  height: 550px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  padding: 5px;
`;

const DashboardHeader = styled.div`
  background: linear-gradient(45deg, rgb(13, 207, 55), rgb(13, 110, 9));
  padding: 5px 5px;
  border-radius: 8px 8px 0 0;
`;

const ProfileHeader = styled.div`
 background: linear-gradient(45deg, rgb(13, 207, 55), rgb(13, 110, 9));
padding: -10px 10px;
border-radius: 8px 8px 0 0;
`;

const DashboardTitle = styled.h2`
  font-size: 1.1rem;
  color: #fff;
  font-weight: 600;
  margin: 0;
`;

const DashboardPreview = styled.div`
  width: 100%;
  height: 180px;
  border-radius: 1px;
  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: cover;
  background-position: center;
`;

const ProfilingTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(241, 247, 242);
  margin-top: 12px;
  margin-bottom: 7px;
  padding-left: 10px;
`;

const ChartWrapper = styled.div`
  width: 100%;
  height: 350px;
  padding: 10px 5px;
`;
